import React, { useLayoutEffect, useRef, useState } from 'react';

// import styled components
import {
  ProgramFeaturesItemContent,
  ProgramFeaturesItemImageWrapper,
  ProgramFeaturesItemWrapper,
} from './styled';

const ProgramFeaturesItem = ({ Icon, title }) => {
  const contentRef = useRef(null);
  const titleRef = useRef(null);

  /** don't actually need to use the state value here anywhere */
  const [, setHasWidth] = useState(false);

  /**
   * forces a re-render when the ref dom nodes have rendered
   * necessary to ensure that the clientWidth gets passed into the prop
   */
  useLayoutEffect(() => {
    setHasWidth(true);
  }, [contentRef.current && titleRef.current]);

  return (
    <ProgramFeaturesItemWrapper>
      <ProgramFeaturesItemImageWrapper>
        <Icon />
      </ProgramFeaturesItemImageWrapper>
      <ProgramFeaturesItemContent
        contentWidth={contentRef.current ? contentRef.current.clientWidth : 0}
        titleWidth={titleRef.current ? titleRef.current.clientWidth : 0}
        ref={contentRef}
      >
        <h2 ref={titleRef}>{title}</h2>
      </ProgramFeaturesItemContent>
    </ProgramFeaturesItemWrapper>
  );
};

export default ProgramFeaturesItem;
